
















import Component, { mixins } from "vue-class-component";
import AxiosMixin from "../mixins/axiosMixin";
@Component({})
export default class TransmissionInlineFrame extends mixins(AxiosMixin) {
  private url = "";
  private height = 0;
  private isTrial = window.is_trial;

  mounted() {
    this.postJsonCheck(
      window.base_url + "/api/iframe_url/get",
      {
        id: 3
      },
      res => {
        this.url = res.data.announce.url;
        this.height = res.data.announce.height;
      }
    );
  }

  //-----------------------------------
  // 伝送ページ遷移用OneTimeToken取得
  //-----------------------------------
  private getOneTimeToken() {
    this.postJsonCheck(
      window.base_url + "/api/office/transmission/token",
      {},
      res => {
        console.log(res);
        this.openTransmissionRelay(res.data.one_time_token);
      }
    );
  }
  //-----------------------------------
  // 伝送ページ遷移（バックエンドの静的ページを別タブで起動）
  //-----------------------------------
  private openTransmissionRelay(token: string) {
    const url = `${window.base_url}/transmission/relay?t=${token}`;
    window.open(url, "_blank");
  }
}
